<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="200px" :rules="rules">
				<el-row>
				
					<el-col :span="12">
						<el-form-item label="学生姓名" prop="actualName"><el-input v-model="formParameter.actualName"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						 
						<el-form-item label="手机号码" prop="phone"><el-input v-model="formParameter.phone"
								autocomplete="off"></el-input></el-form-item>
				 
					</el-col>
				</el-row>
				<el-row>
				
					<el-col :span="12">
						<el-form-item label="登录帐号" prop="loginName"><el-input v-model="formParameter.loginName"
								autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="状态" prop="disabledFlag">{{formParameter.gender==1?'男':'女'}} - {{formParameter.disabledFlag==1?'已禁用':'正常'}}  </el-form-item>
					</el-col>
				 
				 
				
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="更新时间" prop="updateTime"><el-date-picker v-model="formParameter.updateTime"
								align="right" type="date" placeholder="选择日期" :picker-options="pickerOptions">
							</el-date-picker></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="创建时间" prop="createTime"><el-date-picker v-model="formParameter.createTime"
								align="right" type="date" placeholder="选择日期" :picker-options="pickerOptions">
							</el-date-picker></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					
					<el-col :span="24">
						<el-form-item label="备注" prop="remark"><el-input type="textarea" :row="4" v-model="formParameter.remark"
								autocomplete="off"></el-input></el-form-item>
					</el-col>

				</el-row>

				<el-row>
					<el-col :span="24">
			
																									
					<el-table :data="listFrom" style="width: 100%">
						<el-table-column prop="name" label="课程名称">
							<template slot-scope="scope">
					                  {{ scope.row.name }}&nbsp;[ {{ scope.row.year }}]
					       </template>

						</el-table-column>
						<el-table-column prop="paytm" label="支付时间"></el-table-column>	
						<el-table-column prop="untilTime" label="过期时间"></el-table-column>	
						<el-table-column prop="cost" label="金额"></el-table-column>	
					</el-table>
														
																		
					</el-col>	
				</el-row>

				
			</el-form>
		</div>
		<div slot="footer">
		 
			<el-button @click="close">关 闭</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '../../../api/online/temployee/temployee';
export default {
	name: 'edit',
	components: {
		popup
	},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			formParameter: {},
			pickerOptions:[],
			rules: { },
			listFrom:[]

		};
	},
	methods: {




		//打开弹框
		open(parameter, title, disabled, size) {
			
			this.formParameter = parameter;
			this.disabled = disabled;
			this.$refs.popup.open(title, size);
             

			let params = {
				employeeId:this.formParameter.employeeId
			}
			api.order(params, response => {
				this.listFrom = response.data;
			})

			console.log("ss",this.formParameter)

			console.log("ss2222",this.listFrom)
			 
		},
		//关闭弹框
		close() {
			console.log('关闭弹框');
			this.disabled = false;
			this.$refs.popup.close();
		},
	 
		 
		 
	},
	mounted(){
		 
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
